import { getNamePartOrBlank } from "./getNamePartOrBlank";

export const getLastNameOrBlank = (text: unknown) => getNamePartOrBlank(text, "last");